












import Vue from "vue";
import Tooltip from "./Tooltip.vue";
import { t } from "@/plugins/i18n";

const version = process.env.VUE_APP_VERSION;

export default Vue.extend({
  components: {
    Tooltip,
  },

  data() {
    return {
      version: version ? t("AlkalmazasVerzio", [version]) : "",
    };
  },
});
